import React from "react"
import {FormattedMessage} from "react-intl"
import {INTEGRATION_KEY} from "../../../state/integration/Constants"
import Integrations from "../../../integration/Integrations"
import {OrderDto} from "../../../state/order/Order"

type OwnProps = {
    object
    order: OrderDto
}

const OrderReservationExported = (props: OwnProps) => {
    const lightspeedUrl = `https://us.merchantos.com/?name=transaction.views.transaction&form_name=view&tab=lines&id=${
        props.object.attributes.externalId}`
    return <div className={"row "}>
        <div className={"col-12"}>
            <p className={"mb-2"}>
                <FormattedMessage
                    id="order.analytics.events.exported.ls_retail.text"
                    defaultMessage="Reserved items for {identifier} have been exported to {integrationKey} as a sale"
                    values={{
                        integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL),
                        identifier: <strong>{props.order?.attributes?.identifier}</strong>,
                    }}
                />
            </p>
        </div>
        <div className={"col-12 d-flex align-items-center flex-wrap"}>
            <div className={"mr-3"}>
                <a href={lightspeedUrl} target="_blank" rel="noreferrer">
                    <img src="/images/lightspeed_retail_logo.png" width="150px"/>
                </a>
            </div>
            <div className={""}>
                <p className={"mb-0"}>
                    <a href={lightspeedUrl} target={"_blank"} className={"btn btn-sm btn-outline-primary"}
                        rel="noreferrer">
                        <FormattedMessage
                            id="invoice.analytics.events.exported.ls_retail.open"
                            defaultMessage="Open sale in Lightspeed"
                        />
                    </a>
                </p>
            </div>
        </div>
    </div>
}


export default OrderReservationExported



// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-reservation-exported-ls-retail.component.tsx